import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=66f28303"
import script from "./BaseDropdown.vue?vue&type=script&lang=js"
export * from "./BaseDropdown.vue?vue&type=script&lang=js"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=66f28303&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports